import { h } from 'preact'
import SpinnerIcon from './SpinnerIcon'

const Spinner = ({ className }) => (
    <p class={`fxs_spinner ${className || ''}`}>
        <SpinnerIcon />
    </p>
)

export default Spinner
